export function compareWithSearchText(str: string, searchText: string) {
    return normalizeStringForSearch(str).indexOf(normalizeStringForSearch(searchText)) != -1;
}

export function normalizeStringForSearch(str: string) {
    // https://chainformation.atlassian.net/browse/FI-3806
    const res = (str || '')
        .toLowerCase()
        .replace(new RegExp('o\u0308', 'g'), 'o')
        .replace(new RegExp('\u00F6', 'g'), 'o')
        .replace(new RegExp('a\u0308', 'g'), 'a')
        .replace(new RegExp('\u00E4', 'g'), 'a')
        .replace(new RegExp('u\u0308', 'g'), 'u')
        .replace(new RegExp('\u00FC', 'g'), 'u')
        .replace(new RegExp('a\u030A', 'g'), 'a')
        .replace(new RegExp('\u00E5', 'g'), 'a');
    return res;
}
